import { useState,memo } from 'react';
import type { FC } from 'react';
import { useTranslation,Trans } from 'react-i18next';
import useWindowWidth from "../common/WindowWidth"
import { GenericSlider } from "../common/GenericSlider/GenericSlider"
import { CustomNextArrow, CustomPrevArrow } from '../common/GenericSlider/SliderArrows/SliderArrows'; 

import resets from '../_resets.module.css';
import classes from './UsageEx.module.scss';



/*Title*/
import { PageTitle } from "../common/PageTitle/PageTitle";
import { SectionTitle } from "../common/SectionTitle/SectionTitle";
import { SectionTitle_sub } from "../common/SectionTitle_sub/SectionTitle_sub";

/*section*/
import { Contact } from "../common/Contact/Contact";


/*images*/
import usageEx_chart01 from "../../assets/images/usageEx_chart01.png";
import usageEx_chart01_en from "../../assets/images/point_chart_EN_02.png";
import Example_img01 from "../../assets/images/gallery_usage01.png";
import Example_img02 from "../../assets/images/gallery_usage02.png";
import Example_img03 from "../../assets/images/gallery_usage03.png";
import Example_img04 from "../../assets/images/gallery_usage04.png";
import Example_img05 from "../../assets/images/gallery_usage05.png";
import Example_img06 from "../../assets/images/gallery_usage06.png";

import workseet_img01 from "../../assets/images/workseet01.png";
import workseet_img02 from "../../assets/images/workseet02.png";
import workseet_img03 from "../../assets/images/workseet03.png";
import workseet_img04 from "../../assets/images/workseet04.png";
import workseet_img05 from "../../assets/images/workseet05.png";

import introductionEx_imgs01 from "../../assets/images/intro01.png";
import introductionEx_imgs02 from "../../assets/images/intro02.png";
import introductionEx_imgs03 from "../../assets/images/intro03.png";

import Event_img01 from "../../assets/images/event01.png";
import Event_img02 from "../../assets/images/event02.png";
import Event_img03 from "../../assets/images/event03.png";
import Event_img04 from "../../assets/images/event04.png";

const workseet_img = {
  '01': workseet_img01,
  '02': workseet_img02,
  '03': workseet_img03,
  '04': workseet_img04,
  '05': workseet_img05
};

const introductionEx_imgs = {
  '01': introductionEx_imgs01
}
const introductionEx2_imgs = {
  '01': introductionEx_imgs02,
  '02': introductionEx_imgs03
};

const introductionExEvent_imgs = {
  '01': Event_img01,
  '02': Event_img02,
  '03': Event_img03,
  '04': Event_img04,
};


interface Props {
  className?: string;
}



export const UsageEx: FC<Props> = memo(function UsageEx(props = {}) {
  const { t,i18n } = useTranslation();
  const windowWidth = useWindowWidth();
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 5; 
  const currentLanguage = i18n.language;
  const isEnglish = currentLanguage === 'en';

  const image = isEnglish ? usageEx_chart01_en : usageEx_chart01;

  const customSettings = {
    dots: false, 
    arrows: false,
    slidesToShow: 1,
    centerPadding: '20%',
  };

  const customPcSettings = {
    dots: false, 
    arrows: false,
    slidesToShow: 3,
    centerPadding: '0',
  };
  
  
  const workseetSliderSettings = {
    infinite: false, 
    centerPadding: '0',
    beforeChange: (current, next) => setCurrentSlide(next),
      nextArrow: <CustomNextArrow hide={currentSlide === totalSlides - 1} />,
      prevArrow: <CustomPrevArrow hide={currentSlide === 0} />,
  };

  return (

    <div className={`${resets.clapyResets} ${classes.usageEx} usageEx contents`}>

<PageTitle
          className={classes.pageTitle}
          title={t('usageex:pageTitle')}
        />

{/*lead block01------------*/}
<section className={classes.leadblock01}>
  <SectionTitle
            className={classes.lead01Title}
            classes={{color:"grad"}}
            text={t('usageex:leadBlock01.sectionTitle')}
          />
          <p className={classes.lead01SubTitle}>
  <Trans i18nKey="usageex:leadBlock01.subtitle" />
  </p>
<div className={classes.lead01TextWrap}>
  <p className={classes.lead01Text}>
  <Trans i18nKey="usageex:leadBlock01.text">
  <br className="sponly" />
  </Trans>
  </p>
</div>
</section>

{/*lead block02------------*/}
<section className={`${classes.leadblock02} contentWidth`}>
<h2 className={classes.lead02Title}>
<Trans i18nKey="usageex:leadBlock02.title" />
  </h2>
  <div className={classes.lead02ContentWrap}>
    <div className={classes.lead02TextWrap}>
      <p className={classes.lead02Text}>
      <Trans i18nKey="usageex:leadBlock02.text" />
      </p>

  </div>
  
    <div className={classes.usageExImgWrap}>
      <img src={image} className={classes.usageEx_img} />
    </div>
  </div>
</section>




{/*gallery------------*/}
<div className={`${classes.gallery} exampleImages`}>
    {windowWidth <= 768 ? (
      <GenericSlider settings={customSettings}>
        <div>
          <img src={Example_img01} className={classes.exampleImage} />
        </div>
        <div>
          <img src={Example_img02} className={classes.exampleImage} />
        </div>
        <div>
          <img src={Example_img03} className={classes.exampleImage} />
        </div>
        <div>
          <img src={Example_img04} className={classes.exampleImage} />
        </div>
        <div>
          <img src={Example_img05} className={classes.exampleImage} />
        </div>
        <div>
          <img src={Example_img06} className={classes.exampleImage} />
        </div>
      </GenericSlider>
    ) : (
      <GenericSlider settings={customPcSettings}>
        <div>
          <img src={Example_img01} className={classes.exampleImage} />
        </div>
        <div>
          <img src={Example_img02} className={classes.exampleImage} />
        </div>
        <div>
          <img src={Example_img03} className={classes.exampleImage} />
        </div>
        <div>
          <img src={Example_img04} className={classes.exampleImage} />
        </div>
        <div>
          <img src={Example_img05} className={classes.exampleImage} />
        </div>
        <div>
          <img src={Example_img06} className={classes.exampleImage} />
        </div>
      </GenericSlider>
    )}
  </div>



{/*worksheet------------*/}
<section className={`${classes.workSheet} contentWidth`}>
  <SectionTitle
    className={classes.workSheetTitle}
    classes={{color:"grad"}}
    text={t('usageex:worksheet.sectionTitle')}
  />


<GenericSlider settings={workseetSliderSettings}>
    {Object.keys(t('usageex:worksheet.workseetSliderItem', { returnObjects: true })).map((key, index) => {
      const slide = t(`usageex:worksheet.workseetSliderItem.${key}`, { returnObjects: true });

      return (
        <div key={index}>
          <div className={classes.workseetSliderItem}>
            <div className={classes.titleWrap}>
              <div className={classes.number}>{key}</div>
              <div className={classes.title} dangerouslySetInnerHTML={{ __html: slide.title }}></div>
            </div>
            <img src={workseet_img[key]} className={classes.workseetImage} />
          </div>
        </div>
      );
    })}
  </GenericSlider>

</section>


{/*IntroductionEx-----------*/}
<section className={classes.introductionEx}>
  <SectionTitle className={classes.introductionExTitle} text={t('usageex:introductionEx.sectionTitle')} />

  <ul className={classes.introductionExList}>
    {t('usageex:introductionEx.items', { returnObjects: true }).map((item, index) => {
      const key = (index + 1).toString().padStart(2, '0'); // 01, 02, ...

      return (
        <li className={classes.introductionExListItem} key={index}>
          <div className={classes.introductionExCard}>
            <h3 className={classes.introductionExItemTitle}>{item.schoolName}</h3>
            <p className={classes.introductionExItemText}>{item.text}</p>
          </div>
          <div className={classes.introductionExItemImg}>
            <img src={introductionEx_imgs[key]} alt='' />
          </div>
        </li>
      );
    })}
  </ul>

  <SectionTitle className={classes.introductionExTitle} text={t('usageex:introductionEx2.sectionTitle')} />

  <ul className={classes.introductionExList}>
    {t('usageex:introductionEx2.items', { returnObjects: true }).map((item, index) => {
      const key = (index + 1).toString().padStart(2, '0'); // 01, 02, ...

      return (
        <li className={classes.introductionExListItem} key={index}>
          <div className={classes.introductionExCard}>
            <h3 className={classes.introductionExItemTitle}>{item.schoolName}</h3>
            <p className={classes.introductionExItemText}>{item.text}</p>
          </div>
          <div className={classes.introductionExItemImg}>
            <img src={introductionEx2_imgs[key]} alt='' />
          </div>
        </li>
      );
    })}
  </ul>
</section>


<section className={`${classes.introductionExEvent} LargeMarginUnder`}>
  <SectionTitle className={classes.introductionExTitle} classes={{color:"grad"}} text={t('usageex:introductionExEvent.sectionTitle')}  />

  <ul className={classes.introductionExList}>
    {t('usageex:introductionExEvent.items', { returnObjects: true }).map((item, index) => {
      const key = (index + 1).toString().padStart(2, '0'); // 01, 02, ...

      return (
        <li className={`${classes.introductionExListItem} ${index % 2 === 0 ? classes.leftImg : ''}`} key={index}>
          <div className={classes.introductionExCard}>
            <div className={classes.introductionExCategory}>{item.category}</div>
            <h3 className={classes.introductionExItemSchoolName}>{item.schoolName}</h3>
            <p className={classes.introductionExItemText}>{item.text}</p> {/* 注意: item.description を item.text に変更しました */}
          </div>
          <div className={classes.introductionExItemImg}>
            <img src={introductionExEvent_imgs[key]} alt='' />
          </div>
        </li>
      );
    })}
  </ul>
</section>





{/*contact------------*/}
<Contact className={classes.contact} />
    </div>
  );
});
